import AutoPortfolioView from './views/AutoPortfolioView.vue';

const routes = [
  {
    name: 'auto-portfolio',
    path: '/advisor/checkup/auto-portfolio',
    component: AutoPortfolioView,
  },
];

export default routes;
